function Ranking() {
  return (
    <section id="ranking" className="sidebar-box">
      <div className="box-header">
        <h3>Ranking</h3>
        <div className="toggle-buttons">
          <button className="toggle-btn active">Road</button>
          <button className="toggle-btn">Oval</button>
        </div>
      </div>
      <ul className="ranking-list">
        <li className="ranking-item">
          <span className="rank-pos">1</span>
          <span className="rank-name">Max Verstappen</span>
          <span className="rank-rating">9200</span>
        </li>
        <li className="ranking-item">
          <span className="rank-pos">2</span>
          <span className="rank-name">Tony Kanaan</span>
          <span className="rank-rating">8500</span>
        </li>
      </ul>
      <a href="#" className="view-all">Ver ranking completo</a>
    </section>
  );
}

export default Ranking;